/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerSignupFunctionalError
 */
export interface FreelancerSignupFunctionalError {
    /**
     * 
     * @type {string}
     * @memberof FreelancerSignupFunctionalError
     */
    code: FreelancerSignupFunctionalErrorCodeEnum;
}


/**
 * @export
 */
export const FreelancerSignupFunctionalErrorCodeEnum = {
    AccountAlreadyExistsForEmail: 'ACCOUNT_ALREADY_EXISTS_FOR_EMAIL',
    AlreadyFreelancer: 'ALREADY_FREELANCER',
    BlockedCountryError: 'BLOCKED_COUNTRY_ERROR',
    EducationNotFound: 'EDUCATION_NOT_FOUND',
    EmailDomainNotAuthorized: 'EMAIL_DOMAIN_NOT_AUTHORIZED',
    EmailValidationCodeDoesNotMatch: 'EMAIL_VALIDATION_CODE_DOES_NOT_MATCH',
    EmailValidationCodeExpired: 'EMAIL_VALIDATION_CODE_EXPIRED',
    EmailValidationCodeTooManyAttempts: 'EMAIL_VALIDATION_CODE_TOO_MANY_ATTEMPTS',
    EmailValidationCodeTooSoon: 'EMAIL_VALIDATION_CODE_TOO_SOON',
    ExperienceNotFound: 'EXPERIENCE_NOT_FOUND',
    InvalidFirstname: 'INVALID_FIRSTNAME',
    InvalidLastname: 'INVALID_LASTNAME',
    InvalidEducation: 'INVALID_EDUCATION',
    InvalidExperience: 'INVALID_EXPERIENCE',
    NoWorkflowFound: 'NO_WORKFLOW_FOUND',
    ProfilePictureNoFace: 'PROFILE_PICTURE_NO_FACE',
    UserShouldBeLoggedIn: 'USER_SHOULD_BE_LOGGED_IN',
    WorkflowAlreadyExistForEmail: 'WORKFLOW_ALREADY_EXIST_FOR_EMAIL',
    WorkflowAlreadyExistForSession: 'WORKFLOW_ALREADY_EXIST_FOR_SESSION',
    WorkflowInvalidForCreation: 'WORKFLOW_INVALID_FOR_CREATION'
} as const;
export type FreelancerSignupFunctionalErrorCodeEnum = typeof FreelancerSignupFunctionalErrorCodeEnum[keyof typeof FreelancerSignupFunctionalErrorCodeEnum];


/**
 * Check if a given object implements the FreelancerSignupFunctionalError interface.
 */
export function instanceOfFreelancerSignupFunctionalError(value: object): value is FreelancerSignupFunctionalError {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function FreelancerSignupFunctionalErrorFromJSON(json: any): FreelancerSignupFunctionalError {
    return FreelancerSignupFunctionalErrorFromJSONTyped(json, false);
}

export function FreelancerSignupFunctionalErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerSignupFunctionalError {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function FreelancerSignupFunctionalErrorToJSON(value?: FreelancerSignupFunctionalError | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
    };
}

